import { ObjectType } from '@editor/types';
import { DrawerSnapPoints } from '@repo/ui-kit/components/modules/Drawer';

export enum HeaderMobilePanel {
  MainMenu = 'mainMenu',
  DownloadAndShare = 'downloadAndShare',
}

// TODO: unify it with LeftMenuPanel
export enum FooterMobilePanel {
  Template = 'template',
  Add = 'add',
  Texture = 'texture',
  Layers = 'layers',
  ColorPalette = 'colorPalette',
  KittlAi = 'kittlAi',
  Libraries = 'libraries',
}

type State = {
  isOpen: boolean;
  snapPoint: DrawerSnapPoints;
  availableSnapPoints: DrawerSnapPoints[];
  activePanel: HeaderMobilePanel | FooterMobilePanel | ObjectType | null;
};

type Action = {
  setState: (state: Partial<State>) => void;
  setIsOpen: (isOpen: State['isOpen']) => void;
  setSnapPoint: (snapPoint: State['snapPoint']) => void;
};

export type MobileDrawerStoreState = State & Action;
